import { type JurisdictionApi } from '@api/jurisdictions';

import { type Jurisdiction } from './types';

/** Transform single jurisdiction from API data */
export const jurisdictionItemModel = (jurisdictionData: JurisdictionApi): Jurisdiction => ({
  id: jurisdictionData.id,
  iso: jurisdictionData.countryDetail.iso,
  name: jurisdictionData.name,
  countryId: jurisdictionData.country,
});
